import { Euler, MathUtils } from 'three';
export class HeadTracking {
    enabled = true;
    speed = 1;
    target = [0, 0];
    value = [0, 0];
    velocity = [0, 0];
    lastActivity = 0;
    limits = { yaw: 35, pitch: 22, roll: 5 };
    pointer(x: number, y: number, rect: DOMRect) { this.target = [MathUtils.clamp((x - (rect.left + rect.width / 2)) / Math.max(250, rect.width / 2), -1, 1), MathUtils.clamp(-(y - (rect.top + rect.height / 2)) / Math.max(250, rect.height / 2), -1, 1)]; this.lastActivity = performance.now(); }
    update(dt: number, time: number, reduced: boolean) {
        const active = this.enabled && performance.now() - this.lastActivity < 2400;
        for (let i = 0; i < 2; i++) {
            const target = active ? this.target[i] : 0;
            const k = 42 * this.speed;
            this.velocity[i] += (k * (target - this.value[i]) - 2 * Math.sqrt(k) * this.velocity[i]) * dt;
            this.value[i] += this.velocity[i] * dt;
        }
        const idle = reduced ? 0 : Math.sin(time * .31) * .014;
        const pitch = MathUtils.degToRad(Math.max(0, this.limits.pitch)), yaw = MathUtils.degToRad(Math.max(0, this.limits.yaw));
        return new Euler(MathUtils.clamp(-this.value[1] * pitch + idle, -pitch, pitch), MathUtils.clamp(this.value[0] * yaw + idle, -yaw, yaw), Math.sin(time * .27) * (reduced ? 0 : Math.min(.009, MathUtils.degToRad(Math.max(0, this.limits.roll)))), 'YXZ');
    }
}
